import React from 'react'
import styled from 'styled-components'
import Responsive from '../../assets/config/Responsive'
import Colors from '../../assets/styles/Colors'
// @ts-ignore
import { useTranslation } from 'react-i18next'
import FindSupportImg from '../../assets/img/find-support-img.png'
import FraniIcon from '../../assets/v2/JSX/FraniIcon'
import RedChatIcon from '../../assets/v2/JSX/RedChatIcon'
// import { setLiveChatVisibility } from '../../store/liveChatSlice'
import { useNavigate } from 'react-router-dom'

const FindAnswerBanner: React.FC<{
  isFrani?: boolean
}> = ({ isFrani = false }) => {
  //
  // const dispatch = useAppDispatch()
  //
  const navigate = useNavigate()
  //
  const { t } = useTranslation()
  //
  return (
    <Wrapper>
      <Img src={FindSupportImg} alt="support-bunner" />
      <Content>
        <H6>{t('supportBannerTitle')}</H6>
        <P>{t('supportBannerDescription')}</P>

        {isFrani ? (
          <FraniDiv onClick={() => navigate('/category')}>
            <FraniIcon /> <span>{t('priceCalculation')}</span>
          </FraniDiv>
        ) : (
          <ChatDiv
            style={{
              cursor: 'pointer',
              userSelect: 'none',
            }}
            // onClick={() => dispatch(setLiveChatVisibility('maximized'))}
          >
            <ChatIconStyle /> <span>{t('startChatMsg')}</span>
          </ChatDiv>
        )}
      </Content>
    </Wrapper>
  )
}
//
const ChatIconStyle = styled(RedChatIcon)`
  width: 24px;
  min-width: 24px;
  height: 24px;
  margin-right: 12px;
`
const ChatDiv = styled.div`
  display: flex;
  align-items: center;

  span {
    font-size: 18px;
    color: ${Colors.primaryBlack};
  }
`
const FraniDiv = styled(ChatDiv)`
  /*  */
  cursor: pointer;
  /*  */
  svg {
    margin-bottom: -1px;
  }
  transform: translate(200ms ease);

  &:hover {
    span {
      transform: translate(200ms ease);
      opacity: 0.8;
    }
  }
`
const H6 = styled.h6`
  font-size: 36px;
  color: ${Colors.primaryBlack};
  margin-bottom: 0px;

  ${Responsive.tablet} {
    font-size: 22px;
  }
  ${Responsive.mobile} {
    font-size: 22px;
  }
`
const P = styled.p`
  font-size: 18px;
  color: ${Colors.nevadaGrey};
  margin-bottom: 0px;

  ${Responsive.tablet} {
    font-size: 14px;
  }
  ${Responsive.mobile} {
    font-size: 14px;
  }
`
const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  border-radius: 8px;
`
const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 65px 87px;
  height: 100%;
  position: sticky;
  z-index: 2;

  ${Responsive.tablet} {
    padding: 40px 33px;
  }
  ${Responsive.mobile} {
    padding: 40px 33px;
  }
`
const Wrapper = styled.div`
  height: 260px;
  border-radius: 8px;
  margin-top: 100px;
  position: relative;

  ${Responsive.tablet} {
    height: 200px;
    margin-top: 56px;
  }
`
//
export default FindAnswerBanner
